import { ApolloConsumer } from '@apollo/react-hooks';
import React from 'react';

const WithApolloClient = (Component) => (props) =>
    <ApolloConsumer>{(client) => <Component {...props} client={client} />}</ApolloConsumer>;
export default WithApolloClient;
